import { useEffect, useState } from "react";
import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { API } from "aws-amplify";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import AppLocale from "../../lang";
import {
  Localization,
  selectTheme,
  showFooter,
  showLoading,
  showLoginPopup,
  ThemeMode,
} from "../../features/theme/themeSlice";
import {
  PlayerMode,
  selectPlayer,
  updateAccount,
} from "../../features/player/playerSlice";
import {
  CheckAccountStateQuery,
  Game,
  GenerateGameSessionTokenTimelessTechMutation,
  GetGameByIdQuery,
  SessionManagementMutation,
} from "../../API";
import {
  generateGameSessionTokenTimelessTech,
  sessionManagement,
} from "../../graphql/mutations";
import { selectConfig } from "../../features/configapp";
import { checkAccountState, getGameById } from "../../graphql/queries";
import useAccount from "../../hooks/useAccount";

type LocationState = {
  gameId: string;
};

const Poker: React.FC = () => {
  const dispatch = useDispatch();
  const theme = useAppSelector(selectTheme);
  const locale: Localization = theme.language as any;
  const languages: any = { it: "it-IT", en: "en-US" };
  const language = languages[locale];
  const currentAppLocale = AppLocale[locale];
  const config = useAppSelector(selectConfig);
  const location = useLocation();
  const locationState = location.state as LocationState;
  const [gameId, setGameId] = useState(47000);
  const userAccount = useAccount();
  const [gameProvider, setGameProvider] = useState(
    "9c14ca7b-8428-426e-aa32-3cfa7266a176" // "b45e31ed-d54b-40fe-9fda-c208ff5502f7"
  );
  const [sessionToken, setSessionToken] = useState(null);
  const [game, setGame] = useState<Game | null>(null);
  const navigate = useNavigate();

  const player = useAppSelector(selectPlayer);

  const closeSession = (callback: (result: any) => void) => {
    const session: () => string = () => {
      return sessionToken;
    };
    console.log("session close", sessionToken);
    (async () => {
      const result: GraphQLResult<SessionManagementMutation> =
        (await API.graphql({
          query: sessionManagement,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {
            session: session(),
            oper: "SESSION_CLOSE",
          },
        })) as GraphQLResult<SessionManagementMutation>;
      if (result.data.sessionManagement) {
        return result.data.sessionManagement;
      } else return null;
    })().then((r) => {
      if (callback) {
        callback(r);
      }
    });
  };

  useEffect(() => {
    window.scrollTo({top: 0, left: 0});
    return () => {
      if (sessionToken) {
        closeSession(sessionToken);
        (async () => {
          try {
            const result: GraphQLResult<CheckAccountStateQuery> =
              (await API.graphql({
                query: checkAccountState,
                authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
              })) as GraphQLResult<CheckAccountStateQuery>;

            dispatch(updateAccount(result.data.checkAccountState));
          } catch (reason) {
            console.log(JSON.stringify(reason));
          }
        })().catch((reason) => {
          console.log(reason);
        });
      }
    };
  }, [sessionToken]);

  const generateSession = (amount: number) => {
    (async () => {
      try {
        const result: GraphQLResult<GenerateGameSessionTokenTimelessTechMutation> =
          (await API.graphql({
            query: generateGameSessionTokenTimelessTech,
            authMode: player.logged
              ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
              : GRAPHQL_AUTH_MODE.AWS_IAM,
            variables: {
              currency: player.account ? player.account.valute : "EUR",
              lang: language,
              gameId: `${gameProvider}#${gameId}`,
              buyIn: amount,
              category: "Poker",
            },
          })) as GraphQLResult<GenerateGameSessionTokenTimelessTechMutation>;

        if (result.data.generateGameSessionTokenTimelessTech.length > 20)
          setSessionToken(result.data.generateGameSessionTokenTimelessTech);
      } catch (e) {
        console.error(e);
      }
    })();
  };

  useEffect(() => {
    if (gameId) {
      (async () => {
        const result: GraphQLResult<GetGameByIdQuery> = (await API.graphql({
          query: getGameById,
          authMode: player.logged
            ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
            : GRAPHQL_AUTH_MODE.AWS_IAM,
          variables: {
            gameId: `${gameProvider}#${gameId}`,
          },
        })) as GraphQLResult<GetGameByIdQuery>;

        if (result.data.getGameById) {
          console.log(result);
          setGame(result.data.getGameById);
        }
      })();
    }
  }, [gameId]);

  useEffect(() => {
    dispatch(showLoading(true));
    console.log("poker", player);
    dispatch(showFooter(false));

    if (!player.account) {
      if (!player.logged) {
        dispatch(showLoginPopup(true));
        dispatch(showLoading(false));
      } else {
        (async () => {
          try {
            const result: GraphQLResult<CheckAccountStateQuery> =
              (await API.graphql({
                query: checkAccountState,
                authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
              })) as GraphQLResult<CheckAccountStateQuery>;
            console.log("result", result);
            dispatch(updateAccount(result.data.checkAccountState));
            const account = result.data.checkAccountState;
            generateSession(
              account.deposit -
                account.expenses +
                account.winnings +
                account.bonus -
                account.pickedUp
            );
          } catch (reason) {
            dispatch(showLoginPopup(true));
            setTimeout(() => {
              dispatch(showLoading(false));
            }, 1000);
          }
        })().catch((reason) => {
          console.log(reason);
        });
      }

      dispatch(showLoading(false));
    } else {
      dispatch(showLoading(false));
      generateSession(
        player.account.deposit -
          player.account.expenses +
          player.account.winnings +
          player.account.bonus -
          player.account.pickedUp
      );
    }

    return () => {
      dispatch(showLoading(false));
      console.log("SESSION TOKEN", sessionToken);
      closeSession((r) => {
        console.log("result", r);
      });
    };
  }, []);

  return (
    <div className="d-sport">
      {game && sessionToken && (
        <iframe
          loading="eager"
          onLoad={() => {
            dispatch(showLoading(false));
          }}
          src={`https://play.cusinovegaz.com/?mode=real&lobby_id=iconixpoker&token=${sessionToken}&currency=${player.account.valute}&language=${language}&operator_id=PGCasino&home_url=https://pgplatform.eu/`}
          style={{
            position: "fixed",
            width: "100%",
            height: `${
              theme.mode === ThemeMode.KIOSK
                ? "calc(100vh - 60px)"
                : theme.headerStatus
                ? "calc(100vh - 148px)"
                : "calc(100vh - 64px)"
            }  `,
            border: "none",
            outline: "none",
            margin: "-8px 0",
          }}
        />
      )}{" "}
      {/* 
      <iframe
        loading="eager"
        onLoad={() => {
          dispatch(showLoading(false));
        }}
        src="https://release.pokerplaza.com/pgmiami.php"
        style={{
          position: "fixed",
          width: "100%",
          height: `${
            theme.mode === ThemeMode.KIOSK
              ? "calc(100vh - 60px)"
              : theme.headerStatus
              ? "calc(100vh - 148px)"
              : "calc(100vh - 64px)"
          }  `,
          border: "none",
          outline: "none",
          margin: "-8px 0",
        }}
      /> */}
    </div>
  );
};

export default Poker;
